import { formatDurationFromSeconds } from './formatDuration';

const withSign = (value: number, body: string): string => (value > 0 ? `+${body}` : body);

export const formatCsatDelta = (delta: number): string => withSign(delta, delta.toFixed(1));
export const formatPercentDelta = (delta: number): string => withSign(delta, `${delta}%`);
export const formatSecondsDelta = (delta: number): string =>
  withSign(delta, `${delta.toFixed(1)}s`);
export const formatCountDelta = (delta: number): string => withSign(delta, delta.toLocaleString());

// formatDurationFromSeconds rounds negatives toward -Infinity (e.g. -65s renders
// as "-2m -5s"). Format the absolute value and prefix the sign so deltas always
// read cleanly ("-1m 5s", "+45s").
export const formatDurationDelta = (delta: number, subMinuteDecimals = 0): string => {
  if (delta === 0) {
    return formatDurationFromSeconds(0, subMinuteDecimals);
  }
  const formatted = formatDurationFromSeconds(Math.abs(delta), subMinuteDecimals);
  return delta > 0 ? `+${formatted}` : `-${formatted}`;
};
